<template>
  <div class="struct">
    <div class="Company_box">
      <p class="Company_text">公司高管</p>
      <div class="arrow-right" style="margin-top:20px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">你现在所在的位置</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>企业概况</el-breadcrumb-item>
          <el-breadcrumb-item>公司高管</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="member_box">
      <!-- <p class="personnel">公司高级管理人员</p> -->
      <div class="personne_box" v-for="(item, index) in administrator" :key="index">
        <!-- <p class="Board">{{ item.title }}</p> -->
        <div class="enterprise_text ql-editor"  style='white-space: pre-wrap;' v-html="administrator[0].content">
          <!-- <div
            class="name_box2"
            v-for="(items, indexs) in item.data"
            :key="indexs"
          >
            <p>{{ items.fu_title }}</p>
            <p>{{ items.title }}</p>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios"; //注入
import qs from "qs"; //注入
export default {
  data() {
    return {
      administrator: [],
    };
  },
  created() {
    this.Chairmans();
  },
  methods: {
    Chairmans: function () {
      this.$axios({
        method: "get",
        url: "/changhang/index/list?menu=2&type=12",
        // method: "post",
        // data: qs.stringify({
        //   //           id:id,
        // }),
        // url: "/index.php/news/news2",
        // header: {
        //   "Content-Type": "application/x-www-form-urlencoded", //post请求设置
        // },
      }).then((res) => {
        this.administrator = res.data.rows;
        //  this.administrator=res.data.data.data
        // console.log(res,"zzzzzzzzzzzzzzzzz");
      });
    },
  },
};
</script>
<style>
img{
     max-width:100%;
 }

.name_box1 {
  width: 55%;
  /* height: 10vw; */

  /* background: chartreuse; */
  margin: 0 auto;
  margin-top: 10px;

  color: #303133;
}

.member_box {
  width: 80%;
  /* height: 46vw; */
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.enterprise_text {
  width: 100%;
 
}

.personnel {
  /* height: 1.9vw; */
  color: #0b449d;
  font-size: 24px;
  margin: 0 auto;
  margin-left: 19%;
}

.Board {
  width: 50%;
  /* height: 2vw; */
  color: #0b449d;
  font-size: 20px;
  margin: 0 auto;
  text-align: center;
  margin-top: 10px;
}

.name_box2 {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  line-height: 30px;
}

.name_box3 {
  margin-left: -15px;
}

.name_box4 {
  margin-right: -13px;
}

.name_box5 {
  margin-left: -25px;
}

.name_box6 {
  margin-left: -8px;
}

.name_box7 {
  margin-left: -15px;
}

.name_box8 {
  margin-left: -110px;
}

.Company_box {
  width: 100%;
  /* height: 2vw; */
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #dedede;
}

.struct {
  margin-bottom: 5%;
  margin-top: -2%;
  margin-left: 40px;
}

.struct .Company_box {
  /* height: 3.3vw !important; */
}

.Company_text {
  font-weight: bold;
  font-size: 32px;
  color: #0c47a1;
  text-align: center;
  line-height: 2;
}

.struct .el-breadcrumb {
  line-height: 1.5 !important;
  font-size: 0.9vw !important;
}

.arrow-right {
  /* text-align: center;
  margin-top: 1vw; */
}

@media screen and (max-width: 768px) {
  .Company_text {
    width: 25%;
    font-size: 12px !important;
    margin-top: 1.5%;
  }

  .el-breadcrumb {
    font-size: 12px !important;
  }

  .arrow-right {
    width: 100% !important;
  }

  .Company_box {
    width: 180% !important;
    height: 5vw !important;
  }

  .name_box2 {
    line-height: 4vw;
  }

}
</style>
<style >
/* .el-tab-pane {
  margin-left: 40px;
} */
</style>


// WEBPACK FOOTER //
// src/components/Structure.vue